import { NavLink, useLocation } from "react-router";
import { cn, MOCK_ATHLETE_ID, MOCK_ATHLETE_SPORT_ID } from "~/lib/utils";
import IconCollegePlaceholder from "~/components/atoms/IconCollegePlaceholder";
import Image from "~/components/atoms/Image";
import avatarOutlineBlue from "~/assets/avatar-outline-blue.svg";
import avatarFilledBlue from "~/assets/avatar-filled-blue.svg";
import lightbulbOutline from "~/assets/lightbulb-outline.svg";
import lightbulbFilled from "~/assets/lightbulb-filled.svg";
import { RouteIds, useRouteData } from "~/lib/routing";

export default function AuthStickyNav() {
    const { authenticated } = useRouteData(RouteIds.AUTH_MIDDLEWARE);
    const location = useLocation();
    const isCollegesPath = location.pathname.startsWith("/college-recruiting/colleges");
    const isProfilePath = location.pathname.startsWith("/profile");

    const linkStyles = "flex flex-col h-full items-center justify-center menu-link pt-3";
    const linkTextStyles = "text-sm font-bold text-blue-80";
    const activeLinkStyles = "active-top font-bold";

    if (!authenticated) {
        return null;
    }

    return (
        <section className="sticky bottom-0 z-[11] flex min-h-[83px] w-full flex-col border-t border-[theme(colors.blue.20)] bg-white pt-1 shadow-[0px_-6px_8px_0px_rgba(0,0,0,0.15)] sm:hidden">
            <nav
                className="relative flex flex-1 items-stretch justify-around gap-4"
                role="navigation"
            >
                <NavLink
                    to="/college-recruiting/colleges/football"
                    className={cn(isCollegesPath ? activeLinkStyles : "", linkStyles)}
                    aria-label="Navigate to Colleges"
                >
                    <>
                        <IconCollegePlaceholder
                            color={!isCollegesPath ? "blue-outline" : "blue"}
                            className="size-[27px]"
                        />
                        <span className={linkTextStyles}>Colleges</span>
                    </>
                </NavLink>
                <NavLink
                    to={`/profile/${MOCK_ATHLETE_ID}/${MOCK_ATHLETE_SPORT_ID}`}
                    className={cn(isProfilePath ? activeLinkStyles : "", linkStyles)}
                    aria-label="Navigate to Profile"
                >
                    <>
                        {!isProfilePath ? (
                            <Image
                                src={avatarOutlineBlue}
                                alt="Profile Avatar Logo"
                                className="size-[27px]"
                            />
                        ) : (
                            <Image
                                src={avatarFilledBlue}
                                alt="Profile Avatar Logo"
                                className="size-[27px]"
                            />
                        )}
                        <span className={linkTextStyles}>Profile</span>
                    </>
                </NavLink>
                <NavLink
                    to="/resources"
                    className={({ isActive }) => cn(isActive ? activeLinkStyles : "", linkStyles)}
                    aria-label="Navigate to Resources"
                >
                    {({ isActive }) => (
                        <>
                            {!isActive ? (
                                <Image
                                    src={lightbulbOutline}
                                    alt="Resources Logo"
                                    className="size-[27px]"
                                />
                            ) : (
                                <Image
                                    src={lightbulbFilled}
                                    alt="Resources Logo"
                                    className="size-[27px]"
                                />
                            )}
                            <span className={linkTextStyles}>Resources</span>
                        </>
                    )}
                </NavLink>
            </nav>
        </section>
    );
}
AuthStickyNav.displayName = "AuthStickyTabs";
